const createGeologicAgeMap = (geologicAges) => {
  const geologicAgeMap = {};
  geologicAges.forEach((ga) => {
    geologicAgeMap[ga.get('id')] = ga;
  });
  return geologicAgeMap;
};

const createPublicationMap = (publications) => {
  const publicationMap = {};
  publications.forEach((pub) => {
    publicationMap[pub.get('id')] = pub.get('description');
  });
  return publicationMap;
};

export const augmentDeposit = ({
  deposit, geologicAgeMap, publicationMap, geologicAges, publications,
}) => {
  let resolvedGeologicAgeMap = null;
  let resolvedPublicationMap = null;

  if (geologicAgeMap) {
    resolvedGeologicAgeMap = geologicAgeMap;
  } else if (geologicAges) {
    resolvedGeologicAgeMap = createGeologicAgeMap(geologicAges);
  }

  if (publicationMap) {
    resolvedPublicationMap = publicationMap;
  } else if (publications) {
    resolvedPublicationMap = createPublicationMap(publications);
  }

  const geologicAgeId = deposit.get('geologicAgeId');
  const publicationType = deposit.get('publicationType');
  let result = deposit;
  if (resolvedGeologicAgeMap) {
    const ga = resolvedGeologicAgeMap[`${geologicAgeId}`];
    result = result.set('geologicAge', ga ? ga.get('description') : null);
    result = result.set('geologicAgeOrder', ga ? ga.getIn(['extra', 'order']) : null);
  }
  if (resolvedPublicationMap) {
    result = result.set('publication', resolvedPublicationMap[`${publicationType}`]);
  }
  return result;
};

export const augmentData = ({ deposits, geologicAges, publications }) => {
  const geologicAgeMap = geologicAges ? createGeologicAgeMap(geologicAges) : null;
  const publicationMap = publications ? createPublicationMap(publications) : null;
  return deposits.map(deposit => augmentDeposit({
    deposit, geologicAgeMap, publicationMap, geologicAges, publications,
  }));
};
